import {createAction, props} from "@ngrx/store";
import {ActionType} from "@/main/autoreg/accounts/store/action.type";


export const autoRegChangeSettingsActions = createAction(
  ActionType.CHANGE_SETTINGS_ITEM,
  props<{ value: string}>()
)
